<!-- Hero Section -->
<div class="healthcare-section-bg">
    <section class="healthcare-section container py-5">
        <div class="glass-panel-container">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <h1 class="healthcare-heading mb-3">
                        Reimagining Learning with Next-Gen EdTech Software Development
                    </h1>
                    <p class="healthcare-subheading2 mb-4">
                        Building next-generation EdTech platforms powered by AI and accelerated software development,
                        transforming digital education with personalized learning experiences that scale globally.
                    </p>
                    <div class="mb-5 contact-btn">
                        <button class="btn hire-btn hire" (click)="scheduleDemo()">
                            Book a Free Consultation
                        </button>
                    </div>
                </div>

                <div class="col-lg-6 text-center">
                    <video #heroVideo preload="auto" src="../../../../assets/industries/edtech/edtech-herovideo.webm"
                        class="img-fluid hero-image" autoplay loop muted playsinline disablePictureInPicture>
                    </video>
                </div>
            </div>
        </div>
    </section>
</div>
<!-- Software Solutions in Healthcare Section -->
<section class="solutions-section">
    <div class="container">
        <div class="section-header text-center mx-auto">
            <h2>Transforming Education Through Intelligent EdTech Platforms</h2>
        </div>
        <div class="row">
            <div class="col-lg-6">
                <div class="solutions-image-container">
                    <div class="solution-image-card image-one">
                        <div class="image-overlay"></div>
                        <img src="../../../../assets/industries/edtech/edutech-img1.png"
                            alt="Team collaborating on computer">
                    </div>
                    <div class="solution-image-card image-two">
                        <div class="image-overlay"></div>
                        <img src="../../../../assets/industries/edtech/edutech-img2.png"
                            alt="Two colleagues looking at a laptop">
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="solutions-content">
                    <p>
                        The global EdTech market is projected to reach $214 billion by 2026, yet 68% of educational
                        institutions report struggling with outdated systems and limited scalability. Speed to market
                        and platform adaptability have become critical differentiators in this rapidly evolving
                        landscape. Today’s institutions and EdTech providers face challenges like limited learner
                        engagement, outdated LMS systems, and difficulty scaling digital learning platforms.
                    </p>
                    <p>
                        At Kalpita Technologies, we help overcome these challenges through innovative <strong>EdTech
                            software
                            development,</strong> including custom LMS development, e-learning software development
                        services, and
                        AI-powered EdTech solutions. Our team builds secure, high-performance online education platforms
                        that simplify content delivery, improve accessibility, and enhance learning outcomes.
                    </p>
                    <p><strong>Key Benefits of adopting EdTech Software Solutions</strong></p>
                    <div class="features-list">
                        <ul>
                            <li><img src="../../../assets/home/arrow-indicator.svg" alt="Indicator">30-50% faster
                                time-to-market with AI-accelerated workflows</li>
                            <li><img src="../../../assets/home/arrow-indicator.svg" alt="Indicator">2-3x increase in
                                learner engagement & retention through adaptive learning</li>
                            <li><img src="../../../assets/home/arrow-indicator.svg" alt="Indicator">Automated content
                                delivery & assessments reducing administrative overhead by up to 60%</li>
                            <li><img src="../../../assets/home/arrow-indicator.svg" alt="Indicator">Scalable platforms
                                for global learning environments supporting tens of thousands of concurrent users</li>
                            <li><img src="../../../assets/home/arrow-indicator.svg" alt="Indicator">Improved real-time
                                personalization with AI-driven insights from hundreds of learning parameters</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- Our Solutions & Impact Section -->
<section class="impact-section" #impactSection>
    <div class="container">
        <div class="text-center">
            <h2 class="impact-heading">Kalpita Technologies’ EdTech Solutions</h2>
        </div>
        <div class="row align-items-center impact-main-content">
            <!-- Added Animation Trigger -->
            <div class="col-lg-6" [@fadeInUpStagger]="impactSectionVisible ? 'visible' : 'hidden'">
                <!-- Added animate-item class -->
                <p class="impact-description animate-item">
                    Kalpita Technologies delivers end-to-end EdTech software development solutions, from LMS
                    modernization and eLearning mobile app development to online education platform development and
                    AI-powered learning automation.
                    We design platforms that support multimedia content, adaptive learning paths, integrated
                    assessments, and advanced analytics, tailored for schools, universities, enterprises, and EdTech
                    startups.
                </p>
                <!-- Added animate-item class -->
                <p class="impact-description animate-item">
                    Our custom solutions accelerate learning delivery, reduce operational effort, and increase learner
                    satisfaction through intuitive, high-performance digital ecosystems.
                </p>
                <!-- Added animate-item class -->
                <p class="impact-description animate-item">
                    Our EdTech development process leverages cutting-edge AI tools for rapid prototyping, automated
                    testing, and intelligent code optimization. This approach enables us to reduce platform development
                    cycles, deliver MVPs for faster market validation, and implement security best practices via
                    automated vulnerability scanning.
                </p>
            </div>
            <div class="col-lg-6">
                <!-- Added Shine Effect -->
                <div class="impact-image-wrapper">
                    <img src="../../../../assets/industries/edtech/edtechsolutions-img.png"
                        alt="Developer working on multiple screens">
                    <div class="shine"></div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- Case Studies Section -->
<section class="case-studies-section">
    <div class="container">

        <div class="row justify-content-center text-center mb-5">
            <div class="col-lg-8">
                <h2 class="section-heading">Our EdTech Case Studies</h2>
                <!-- <p class="section-subheading">Real-world examples of our healthcare solutions in action.</p> -->
            </div>
        </div>

        <!-- Slider Wrapper -->
        <div class="case-study-slider-container" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">

            <!-- The Sliding Track -->
            <div class="slider-viewport">
                <div class="slider-track" [style.transform]="'translateX(-' + (currentSlide * 100) + '%)'"
                    [class.single-slide]="caseStudies.length === 1">

                    <!-- Loop through Case Studies -->
                    <div class="case-study-slide" *ngFor="let study of caseStudies">
                        <div class="row align-items-center">

                            <!-- Image Column (Left) -->
                            <div class="col-lg-5 d-flex justify-content-center">
                                <div class="case-study-image-wrapper">
                                    <img [src]="study.image" [alt]="study.title" class="img-fluid">
                                </div>
                            </div>

                            <!-- Content Column (Right) -->
                            <div class="col-lg-7">
                                <div class="case-study-content">
                                    <h3 class="case-study-title">{{ study.title }}</h3>
                                    <p class="case-study-description">
                                        {{ study.description }}
                                    </p>
                                </div>
                            </div>

                        </div>
                    </div>
                    <!-- End Loop -->
                </div>
            </div>

            <!-- Pagination Dots -->
            <div class="slider-dots" *ngIf="caseStudies.length > 1">
                <span *ngFor="let study of caseStudies; let i = index" class="dot" [class.active]="i === currentSlide"
                    (click)="goToSlide(i)">
                </span>
            </div>
        </div>
    </div>
</section>
<!-- Testimonial Section -->
<!-- <section class="written-testimonial-section custom-testimonial written-testimonial-wrapper">
  <h2 class="written-heading">Testimonials</h2>

  <app-clients-testimonal [hideHeading]="true"></app-clients-testimonal>
</section> -->
<div class="healthcare-section-bg">
    <section class="healthcare-section container py-5">
        <div class="glass-panel-container">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <h2 class="healthcare-heading mb-3">
                        Testimonials
                    </h2>
                    <div class="mb-5 contact-btn">
                        <button class="btn hire-btn hire" (click)="testimonials()">
                            Explore What Our Clients Say
                        </button>
                    </div>
                </div>

                <div class="col-lg-6 text-center">
                    <img src="../../../../assets/clientscta/clientsctaimage.webp" alt="Clients CTA"
                        class="img-fluid testimonial-hero-image">
                </div>
            </div>
        </div>
    </section>
</div>
<!-- FAQ -->
<app-faq [faqList]="edTechFaqs"></app-faq>
<!-- Final CTA -->
<div class="final-cta-bg">
    <img src="../../../../assets/industries/healthcare/half-tablet.png" alt="Decorative capsule"
        class="cta-capsule-img">
    <section id="final-cta" class="final-cta-section container">
        <div class="section-header text-center mx-auto">
            <!-- <h2>Final CTA</h2> -->
        </div>
        <div class="row align-items-center">
            <div class="col-lg-6 cta-content-col">
                <h2 class="cta-heading-small">Let’s create impactful EdTech solutions together</h2>
                <div class="mb-5 cta-btn-group">
                    <!-- <button class="btn btn-get-started me-3" (click)="getStarted()">
            Get Started
          </button> -->
                    <button class="btn btn-schedule-demo" (click)="scheduleDemo()">
                        Schedule a Free Consultation
                    </button>
                </div>
            </div>
            <div class="col-lg-6 text-center">
                <img src="../../../../assets/industries/healthcare/health-pod-clinic.png" alt="Health POD Clinic"
                    class="img-fluid cta-clinic-image">
            </div>
        </div>
    </section>
</div>
<!-- Explore More Industries -->
<app-explore-more-industries></app-explore-more-industries>